import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import moment from 'moment';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import TablePagination from '@mui/material/TablePagination';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import logoImage from './images/logo.jpg';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import TableSortLabel from '@mui/material/TableSortLabel';
import psdfimage from './images/psdfimage.png';

const reportHeadCells = [
    { id: 'date', numeric: false, label: 'Date' },
    { id: 'type', numeric: false, label: 'Type' },
    { id: 'invoice_number', numeric: false, label: 'Invoice Number' },
	 { id: 'in_reason', numeric: false, label: 'Details' },
    { id: 'total_received_qty', numeric: true, label: 'Quantity In' },
    { id: 'total_dispatched_qty', numeric: true, label: 'Quantity Out' },
    { id: 'total_received_amount', numeric: true, label: 'Value In($)' },
    { id: 'total_dispatched_amount', numeric: true, label: 'Value Out($)' },
];

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort, headCells } = props; // Added headCells prop
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'center' : 'center'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    headCells: PropTypes.array.isRequired, 
};

export default class STockmovementdetailedreport extends Component {
    constructor(props) {
        super(props);

        const currentDate = dayjs();

        this.state = {
            redirect: false,
            ReportData: [],
            page: 0,
            rowsPerPage: 50,
            orderBy: '',
            order: 'asc',
			
            categoryOptions: [],
            selectedCategory: null,
            pr_ca_id: '',
            selectedPeriod: 'This Month',
            openExportDialog: false,
            todate: currentDate.endOf('month'),
            fromdate: currentDate.startOf('month'),
            todate1: currentDate.endOf('month').format('YYYY-MM-DD'),
            fromdate1: currentDate.startOf('month').format('YYYY-MM-DD'),
            fromDateEnabled: false,
            toDateEnabled: false,
            totaldata: 0,
            rowsPaging: [50, 100, 150, 200, 250],
            pagename: '', 
            redirectData: {}, 
            pr_id_from_redirect: null, 
			in_pr_id:'',
			prid:'',
			 totalReceivedQty: 0, 
            totalDispatchedQty: 0, 
            totalReceivedAmount: 0,
            totalDispatchedAmount: 0, 
        };
        this.componentRef = React.createRef();
    }

    getParameterByName(name, url) {
        if (!url) url = window.location.href;
        url = url.toLowerCase();
        name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    componentDidMount() {
        document.title = "Stock Movement Summary Report";
 let strname="Stock Movement Summary Report ";
 this.props.parentdasCallback(
            strname+"~"
        );
        // Check if pr_id is passed via state during navigation
        const { state } = this.props.location || {}; // Access location from props
        if (state && state.pr_id) {
            this.setState({ pr_id_from_redirect: state.pr_id }, () => {
                this.apicall(this.state.page, this.state.rowsPerPage, state.pr_id);
            });
        } else {
            // If not from state, check URL parameter (less common for redirects but good to have)
            const prIdParam = this.getParameterByName('pr_id');
            if (prIdParam) {
                this.setState({ pr_id_from_redirect: prIdParam }, () => {
                    this.apicall(this.state.page, this.state.rowsPerPage, prIdParam);
                });
            } else {
                // If no pr_id, make a regular API call (all data)
                this.apicall(this.state.page, this.state.rowsPerPage);
            }
        }
    }

    updateDateRange = (startDate, endDate) => {
        this.setState({
            fromdate: startDate,
            todate: endDate,
            fromdate1: startDate.format('YYYY-MM-DD'),
            todate1: endDate.format('YYYY-MM-DD')
        });
    }

    handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };

    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    };

    handleClickSearch = () => {
         this.setState({ page: 0 }, () => {
            this.apicall(this.state.page, this.state.rowsPerPage, this.state.pr_id_from_redirect); 
        });
    }

    onchangedateHandler = (event) => {
        let selectedOption = event.target.value;
        const today = dayjs();

        const periodMap = {
            'This Month': [today.startOf('month'), today.endOf('month')],
            'This Quarter': [today.startOf('quarter'), today.endOf('quarter')],
            'This Year': [today.startOf('year'), today.endOf('year')],
            'Last Month': [today.subtract(1, 'month').startOf('month'), today.subtract(1, 'month').endOf('month')],
            'Last Quarter': [today.subtract(1, 'quarter').startOf('quarter'), today.subtract(1, 'quarter').endOf('quarter')],
            'Last Year': [today.subtract(1, 'year').startOf('year'), today.subtract(1, 'year').endOf('year')],
            'This Financial Year': [
                dayjs().month() >= 3 ? dayjs().startOf('year').month(3) : dayjs().subtract(1, 'year').startOf('year').month(3),
                dayjs().month() >= 3 ? dayjs().add(1, 'year').startOf('year').month(2).endOf('month') : dayjs().startOf('year').month(2).endOf('month')
            ],
            'Last Financial Year': [
                dayjs().month() >= 3 ? dayjs().subtract(1, 'year').startOf('year').month(3) : dayjs().subtract(2, 'year').startOf('year').month(3),
                dayjs().month() >= 3 ? dayjs().startOf('year').month(2).endOf('month') : dayjs().subtract(1, 'year').startOf('year').month(2).endOf('month')
            ],
            'Custom': [today, today]
        };

        const [startDate, endDate] = periodMap[selectedOption];

        this.setState({
            selectedPeriod: selectedOption,
            fromdate: startDate,
            todate: endDate,
            fromdate1: startDate.format('YYYY-MM-DD'),
            todate1: endDate.format('YYYY-MM-DD'),
            fromDateEnabled: selectedOption === 'Custom',
            toDateEnabled: selectedOption === 'Custom'
        });
    };

    fromdatehandler = (date) => {
        this.setState({
            fromdate: dayjs(date),
            fromdate1: dayjs(date).format('YYYY-MM-DD'),
        });
    }

    todatehandler = (date) => {
        this.setState({
            todate: dayjs(date),
            todate1: dayjs(date).format('YYYY-MM-DD'),
        });
    }

apicall(page, rowsPerPage) {
    const startIndex = page * rowsPerPage;
	 let search = window.location.href;
    let prid = this.getParameterByName('prid', search);
	if(prid==null)
	{
		prid="";
	}
axios.get( localStorage.getItem("ISIurl") + 'ajaxreports.php?action=inventorystockdetailedreportgetall&in_cmp_id='+localStorage.getItem('ISIcmpid')+'&StartIndex=' + startIndex + '&PageSize=' + rowsPerPage + '&fromdate=' + this.state.fromdate1 + '&todate=' + this.state.todate1+'&in_pr_id='+prid)
         .then(resp => {
            if (resp.data && resp.data.length > 0) {
                let total = 0;
 let strname="Stock Movement Summary Report : "+resp.data[0].pr_code+ ' - ' +resp.data[0].pr_description;
 this.props.parentdasCallback(
            strname+"~"
        );
                if (resp.data[0] && resp.data[0].count !== undefined) {
                    total = parseInt(resp.data[0].count);
                }

                const totalReceivedQty = resp.data.reduce((sum, item) => sum + parseFloat(item.total_received_qty || 0), 0);
                const totalDispatchedQty = resp.data.reduce((sum, item) => sum + parseFloat(item.total_dispatched_qty || 0), 0);
                const totalReceivedAmount = resp.data.reduce((sum, item) => sum + parseFloat(item.total_received_amount || 0), 0);
                const totalDispatchedAmount = resp.data.reduce((sum, item) => sum + parseFloat(item.total_dispatched_amount || 0), 0);

                this.setState({
                    ReportData: resp.data,
                    totaldata: total,
                    totalReceivedQty,
                    totalDispatchedQty,
                    totalReceivedAmount,
                    totalDispatchedAmount,
                });
            } else {
                this.setState({ ReportData: [], totaldata: 0, totalReceivedQty: 0, totalDispatchedQty: 0, totalReceivedAmount: 0, totalDispatchedAmount: 0 });
            }
        })
 
}



    onCategoryChange = (event, newValue) => {
        this.setState({
            selectedCategory: newValue,
            pr_ca_id: newValue ? newValue.id : ''
        });
    };

    handleChangePage = (event, newPage) => {
        this.setState({
            page: newPage,
        }, () => {
            this.apicall(this.state.page, this.state.rowsPerPage, this.state.pr_id_from_redirect); 
        });
    };

    handleChangeRowsPerPage = event => {
        let pageval = event.target.value;

        this.setState({
            page: 0,
            rowsPerPage: parseInt(pageval, 10),
        }, () => {
            this.apicall(this.state.page, this.state.rowsPerPage, this.state.pr_id_from_redirect); // Pass pr_id
        });
    };

    handleRequestSort = (event, property) => {
        const isDesc = this.state.orderBy === property && this.state.order === 'desc';
        this.setState({
            order: isDesc ? 'asc' : 'desc',
            orderBy: property,
        });
    };

	
handleClickOpen = () => {
  
      this.GetLogoForpdf();
  
  };

GetLogoForpdf() {
  axios
    .get(`${localStorage.getItem("ISIurl")}ajaxbusinesssetting.php`, {
      params: {
        action: "getpdflogo",
        bs_cmp_id: localStorage.getItem("ISIcmpid"),
        bs_id: 2,bs_page:5
      },
    })
    .then((resp) => {
      if (resp.data.status === "success") {
        this.setState(
          {
            pdflogo: resp.data.base64,
          },
          () => {
            setTimeout(() => {
              this.handleDownload();
            }, 500);
          }
        );
      } else {
        console.error("Error:", resp.data.message);
      }
    })
    .catch((error) => {
      console.error("Request failed:", error);
    });
}
    handleDownload = () => {
        const { ReportData, fromdate1, todate1 } = this.state;
        const doc = new jsPDF();

        const imgWidth = 40;
        const imgHeight = 12;
        const imgX = (doc.internal.pageSize.width - imgWidth) / 2;
        const imgY = 10;
          if (this.state.pdflogo) {
	 const logoImage = this.state.pdflogo.startsWith('data:image')
      ? this.state.pdflogo
      : `data:image/jpeg;base64,${this.state.pdflogo}`;
  doc.addImage(logoImage, 'JPEG', imgX, imgY, imgWidth, imgHeight);
 }
        const title = 'Inventory Stock Movement Report';
        doc.setFontSize(16);

        const titleY = imgY + imgHeight + 8;
        doc.text(title, doc.internal.pageSize.width / 2, titleY, { align: 'center' });

        doc.setFontSize(10);
        doc.text(`From Date: ${moment(fromdate1).format('DD/MM/YYYY')} To Date: ${moment(todate1).format('DD/MM/YYYY')}`, doc.internal.pageSize.width / 2, titleY + 7, { align: 'center' });

        const tableStartY = titleY + 18;

        const headers = [
            ['Item Code', 'Item Description', 'Quantity In', 'Quantity Out', 'Value In($)', 'Value Out($)']
        ];

        const rows = ReportData.map(item => {
            return [
                item.pr_code,
                item.in_reason, 
                 parseFloat(item.total_received_qty || 0).toFixed(2),
    parseFloat(item.total_dispatched_qty || 0).toFixed(2),
    parseFloat(item.total_received_amount || 0).toFixed(2),
    parseFloat(item.total_dispatched_amount || 0).toFixed(2)
            ];
        });
const totalRow = [
            '', '', '', 'Total:',
            this.state.totalReceivedQty.toFixed(2),
            this.state.totalDispatchedQty.toFixed(2),
            this.state.totalReceivedAmount.toFixed(2),
            this.state.totalDispatchedAmount.toFixed(2)
        ];
        rows.push(totalRow);

        doc.autoTable({
            head: headers,
            body: rows,
            startY: tableStartY,
            theme: 'striped',
            didDrawPage: function (data) {
                var str = "Page " + doc.internal.getNumberOfPages();
                doc.setFontSize(10);
                doc.text(str, doc.internal.pageSize.width / 2, doc.internal.pageSize.height - 10, { align: 'center' });
            }
        });

        doc.save('Stockinventorymovementreport.pdf');
        this.handleCloseExportDialog();
    };

    render() {
        if (this.state.redirect) {
            return <Navigate to={this.state.pagename} state={this.state.redirectData} />;
        }

        const sortedReportData = stableSort(this.state.ReportData, getSorting(this.state.order, this.state.orderBy));

        return (
            <React.Fragment>
                <div className="searchbox">
                    <ul style={{ padding: '0px 1%' }}>
                        <li>
                            <p>Period</p>
                            <p>
                                <Select
                                    native
                                    variant="outlined"
                                    className="txtbox"
                                    margin="normal"
                                    fullWidth
                                    onChange={this.onchangedateHandler}
                                    value={this.state.selectedPeriod}
                                    inputProps={{ tabIndex: "4" }}
                                >
                                    <option value="This Month">This Month</option>
                                    <option value="This Quarter">This Quarter</option>
                                    <option value="This Year">This Year</option>
                                    <option value="Last Month">Last Month</option>
                                    <option value="Last Quarter">Last Quarter</option>
                                    <option value="Last Year">Last Year</option>
                                    <option value="This Financial Year">This Financial Year</option>
                                    <option value="Last Financial Year">Last Financial Year</option>
                                    <option value="Custom">Custom</option>
                                </Select>
                            </p>
                        </li>
                        <li>
                            <p>From Date</p>
                            <p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DatePicker']}>
                                        <DatePicker
                                            disabled={!this.state.fromDateEnabled}
                                            value={dayjs(this.state.fromdate)}
                                            className="txtbox"
                                            onChange={this.fromdatehandler}
                                            format="MM/DD/YYYY"
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </p>
                        </li>
                        <li>
                            <p>To Date</p>
                            <p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DatePicker']}>
                                        <DatePicker
                                            disabled={!this.state.toDateEnabled}
                                            value={dayjs(this.state.todate)}
                                            className="txtbox"
                                            onChange={this.todatehandler}
                                            format="MM/DD/YYYY"
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </p>
                        </li>

                        <li>
                            <p>&nbsp;</p>
                            <p className="searchbutton">
                                <Button type="submit" variant="contained" className="frmSecondarybtn" onClick={this.handleClickSearch}>
                                    Calculate
                                </Button>
                                &nbsp;
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="exportbtn"
                                    onClick={this.handleOpenExportDialog}
                                >
                                    EXPORT
                                </Button>
                            </p>
                        </li>
                    </ul>
                    <div className="clear"></div>
                </div>

                <div className="estimatebox">
                    <Paper>
                        <TableContainer>
                            <Table stickyHeader aria-label="sticky table" id="balance-report-table" style={{ paddings: '0px 10%' }}>

                                <EnhancedTableHead
                                    order={this.state.order}
                                    orderBy={this.state.orderBy}
                                    onRequestSort={this.handleRequestSort}
                                    headCells={reportHeadCells}
                                />
                                <TableBody>
                                    {sortedReportData.length > 0 ? (
                                        sortedReportData.map((item, index) => (
                                            <TableRow
                                                key={index}

                                            >
                                                <TableCell  align={'center'}>{item.indate}</TableCell>
                                                <TableCell  align={'center'}>{item.type}</TableCell>
                                                <TableCell  align={'center'}>{item.in_reason}</TableCell>
												 <TableCell  align={'center'}>{item.in_referencetype} to {item.party_name}</TableCell>
												
                                                <TableCell align={'center'}> {'\u200B' +parseFloat(item.total_received_qty || 0).toFixed(2)}</TableCell>
                                                <TableCell align={'center'}> {'\u200B' +parseFloat(item.total_dispatched_qty || 0).toFixed(2)}</TableCell>
                                                <TableCell align={'center'}> {'\u200B' +parseFloat(item.total_received_amount || 0).toFixed(2)}</TableCell>
                                                <TableCell align={'center'}> {'\u200B' +parseFloat(item.total_dispatched_amount || 0).toFixed(2)}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell align="center" colSpan={reportHeadCells.length}>No Records</TableCell>
                                        </TableRow>
                                    )}
									  {sortedReportData.length > 0 && (
                                        <TableRow style={{ fontWeight: '800', borderTop: '2px solid black' }}>
                                            <TableCell colSpan={4} align="right" style={{ fontWeight: '800'}}>Total:</TableCell>
                                           <TableCell align="center" style={{ fontWeight: '800' }}>
  {'\u200B' + parseFloat(this.state.totalReceivedQty || 0).toFixed(2)}
</TableCell>

<TableCell align="center" style={{ fontWeight: '800' }}>
  {'\u200B' + parseFloat(this.state.totalDispatchedQty || 0).toFixed(2)}
</TableCell>

<TableCell align="center" style={{ fontWeight: '800' }}>
  {'\u200B' + parseFloat(this.state.totalReceivedAmount || 0).toFixed(2)}
</TableCell>

<TableCell align="center" style={{ fontWeight: '800' }}>
  {'\u200B' + parseFloat(this.state.totalDispatchedAmount || 0).toFixed(2)}
</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={this.state.rowsPaging}
                            component="div"
                            count={this.state.totaldata}
                            rowsPerPage={this.state.rowsPerPage}
                            page={this.state.page}
                            onPageChange={this.handleChangePage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                        />
                    </Paper>
                </div>

                <Dialog open={this.state.openExportDialog} onClose={this.handleCloseExportDialog}>
                    <DialogTitle>Stock Inventory Movement report</DialogTitle>
                    <DialogContent>
                        <p> To generate a new report, based on the latest selection criteria you've specified, choose the format you want to use. Depending on the amount of data included on the report, it may take some time to generate.</p>
                      <p style={{ textAlign: "center", display: "flex", justifyContent: "center", gap: "20px" }}>
				  <ReactHTMLTableToExcel
                            id="test-table-xls-button"
                            className="my-custom-excel-button"
                            table="balance-report-table"
                            filename="StockInventoryMovementReport"
                            sheet="Stock Report"
                            buttonText=" "
                        />
                        <img src={psdfimage} width={100} height={100} style={{ cursor: "pointer" }} onClick={this.handleClickOpen} alt="Download PDF" /></p>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseExportDialog} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}